import normalizeITProcessCategory from './normalizeITProcessCategory';

export const mapSupportingProcesses = (item) => {
	const {id, itProcessName: name, itProcessTypeId, itProcessSubTypeID} = item;
	return {
		id,
		name,
		category: normalizeITProcessCategory(item),
		itProcessTypeId: itProcessSubTypeID || itProcessTypeId
	};
};

export default (response) => {
	const {itProcesses = [], ...data} = response?.data?.[0] ?? {};
	return {
		...data,
		itProcesses: itProcesses?.map(mapSupportingProcesses)
	};
};
